<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_v"><b>For Patti Shepherd, Jayanne Angell, and Bill Mullins,</b></a></p><a id="page_v">
<p class="dedit">who believed in my writing before I did</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?68fb4011